module.exports = require('./helpers/bundle-url').getBundleURL('iVhRc') + "logo.c5857b8b.svg";